import { NgModule } from "@angular/core";
import { CircCommonModule } from "../../../common/common.module";
import { LogClass, Logger } from "../../../logger";
import { StepService } from "../../../services";
import { StepTypeCommonModule } from "../common/step-type-common.module";
import { STEPTYPE_MAIL } from "../constants";
import { CreateComponent } from "./create/create.component";
import { TemplateComponent } from "./template/template.component";

@NgModule({
  declarations: [CreateComponent, TemplateComponent],
  imports: [CircCommonModule, StepTypeCommonModule]
})
@LogClass({ source: "StepTypeMailModule" })
export class StepTypeMailModule {
  private logger: Logger;

  constructor(stepService: StepService) {
    this.logger.debug("Register service");

    stepService.register({
      id: STEPTYPE_MAIL,
      name: `step_${STEPTYPE_MAIL}_new_name`,
      description: `step_${STEPTYPE_MAIL}_new_description`,
      createComponent: CreateComponent,
      editComponent: CreateComponent,
      workComponent: CreateComponent, //NoWork component needed
      createTemplateComponent: TemplateComponent,
      editTemplateComponent: TemplateComponent
    });
  }
}
